import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export interface ConfirmData<T> {
  title?: string | null;
  description?: string | null;
  confirmBtn: string;
  cancelBtn: string;
  confirmPayload?: T;
  confirm$?: Subject<T | true>;
  closeOnConfirm?: boolean;
  disableBtnOnConfirm?: boolean;
}

@Component({
  selector: 'md-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmPopupComponent implements OnInit {
  @Input() dialogData?: ConfirmData<any>;
  @Input() forceDisabled?: boolean;
  @Input() canCloseDialog = true;

  @Output() confirmed = new EventEmitter<Event>();
  @Output() closed = new EventEmitter<Event>();
  @Output() canceled = new EventEmitter<Event>();

  disabled = false;

  confirmData!: ConfirmData<any>;

  constructor(
    public dialogRef: MatDialogRef<ConfirmPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmData<any>,
    readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.confirmData = this.data || this.dialogData;
    const width = this.dialogRef._containerInstance._config.width;
    if (!width || parseInt(width, 10) < 440) {
      this.dialogRef.updateSize('440px');
    }
  }

  closeDialog(payload: any) {
    if (this.canCloseDialog) {
      this.dialogRef.close(payload);
    }
  }

  close() {
    this.closeDialog(undefined);
    this.closed.emit();
  }

  cancel() {
    this.closeDialog(false);
    this.canceled.emit();
  }

  confirm() {
    if (this.confirmData.disableBtnOnConfirm) {
      this.disabled = true;
    }

    this.confirmed.emit();
    const confirmPayload = this.confirmData.confirmPayload || true;
    if (this.confirmData.closeOnConfirm) {
      this.closeDialog(confirmPayload);
    }

    if (this.confirmData.confirm$) {
      this.confirmData.confirm$.next(confirmPayload);
    }
  }
}
